let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZeIW")).then(() => parcelRequire('cfAGP'));